<template>
   <swiper
    id="swiper"
    :allowTouchMove="false"
    :direction="'vertical'"
    :slidesPerView="1"
    :spaceBetween="0"
    :shortSwipes="false"
    :longSwipesRatio="0.1"
    :longSwipesMs="100"
    @setTranslate="initSwipe"
    @activeIndexChange="activeIndexChange"
    @afterInit="afterInit"
    :pagination="{
      clickable: true,
    }"
    :modules="modules"
    class="mySwiper"
  >
    <swiper-slide>
      <homeslide1-vue ref="home1" style="width:100%;height:100%;"></homeslide1-vue>
    </swiper-slide>
    <swiper-slide>
      <homeslide2-vue ref="home2" style="width:100%;height:100%;"></homeslide2-vue>
    </swiper-slide>
    <swiper-slide>
      <homeslide3-vue ref="home3" style="width:100%;height:100%;"></homeslide3-vue>
    </swiper-slide>
    <swiper-slide>
      <homeslide4-vue ref="home4" style="width:100%;height:100%;"></homeslide4-vue>
    </swiper-slide>
    <swiper-slide>
      <homeslide5-vue id="homeslide5" style="width:100%;height: 90px;"></homeslide5-vue>
    </swiper-slide>
  </swiper>
</template>

<script>
import {ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import homeslide1Vue from "../components/home/homeslide1.vue";
import homeslide2Vue from "../components/home/homeslide2.vue";
import homeslide3Vue from "../components/home/homeslide3.vue";
import homeslide4Vue from "../components/home/homeslide4.vue";
import homeslide5Vue from "../components/home/homeslide5.vue";
import "swiper/css";
import "swiper/css/pagination";
import {Pagination, Scrollbar, Virtual } from "swiper";

export default {
  name: 'App',
  components: {
    Swiper,
    SwiperSlide,
    homeslide1Vue,
    homeslide2Vue,
    homeslide3Vue,
    homeslide4Vue,
    homeslide5Vue
  },
  setup() {
    const swiperRef = ref(null);
    const swiperBool = ref(true);
    const swiperPosition = ref(0);  //0 是初始化， 1是向上，deltaY为-   2是向下， deltaY为+
    const swiperDistance = ref(0);

    const wheelControl = (event) => {
      if (swiperBool.value == false) return
        event = event || window.event;
        let a = document.getElementById('swiper')
        let less = a.clientHeight - window.innerHeight
        let scrollTop = document.documentElement.scrollTop
        if (swiperPosition.value == 0) {
          if (less - scrollTop <= 2 && event.wheelDelta < 0 && Math.abs(event.deltaY) > 50) {
            swiperDistance.value = 0;
            if (swiperRef.value.activeIndex != 4) {
              swiperPosition.value = 1;
              if (window.innerHeight > 878) {
                wheelControl(event)
                return
              }
              swiperBool.value = false;
              setTimeout(() => {
                swiperBool.value = true
              }, 500);
            }
          } else if (scrollTop <= 2 && event.wheelDelta > 0 && Math.abs(event.deltaY) > 50) {
            swiperDistance.value = 0;
            if (swiperRef.value.activeIndex != 0) swiperPosition.value = 2;
          }
        } else if (swiperPosition.value == 1) {
          if (event.wheelDelta > 0 && Math.abs(event.deltaY) > 50) {
            swiperPosition.value = 0
          } else {
            swiperDistance.value = swiperDistance.value + Math.abs(event.deltaY)
            if (swiperDistance.value > 0) {
              swiperBool.value = false
              swiperRef.value.slideTo(swiperRef.value.activeIndex + 1, 800, false)
              if (swiperRef.value.activeIndex < 4) {
                setTimeout(() => {
                  document.documentElement.scrollTop = 0
                }, 800);
              }
              setTimeout(() => {
                  swiperBool.value = true
                  swiperPosition.value = 0
                }, 800);
            }
          }
        } else if (swiperPosition.value == 2) {
          swiperDistance.value = swiperDistance.value + Math.abs(event.deltaY)
            if (swiperDistance.value > 0) {
              swiperBool.value = false
              swiperRef.value.slideTo(swiperRef.value.activeIndex - 1, 500, true)
              setTimeout(() => {
                swiperBool.value = true
                swiperPosition.value = 0
              }, 800);
            }
        }
    };

    onMounted(() => {
      document.documentElement.scrollTop = 0
      document.body.onmousewheel = wheelControl;

      document.body.addEventListener("DOMMouseScroll", wheelControl);
    });
    let home1 = ref(null)
    let home2 = ref(null)
    let home3 = ref(null)
    let home4 = ref(null)
    const beforeSelected = ref(0)

    const afterInit = (swiper) =>{
      swiperRef.value = swiper
      home1.value.changeAnime()
      beforeSelected.value = 0
    };

    const activeIndexChange = (swiper) =>{
      if (swiper.activeIndex == 0) {
        home1.value.changeAnime()
        beforeSelected.value = 0
      }else if (swiper.activeIndex == 1) {
        home2.value.changeAnime()
        beforeSelected.value = 1
      } else if (swiper.activeIndex == 2) {
        home3.value.changeAnime()
        beforeSelected.value = 2
      } else if (swiper.activeIndex == 3) {
        let show = beforeSelected.value != 4 ? false : true
        home4.value.changeAnime(show)
        beforeSelected.value = 3
      } else if (swiper.activeIndex == 4) {
        beforeSelected.value = 4
      }
    };
    const initSwipe = (swiper) =>{
      let screen = document.getElementById('homeslide5')
      let screenHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      let weight = (screenHeight * -3) - screen.clientHeight
      if (swiper.translate < weight) {
        swiper.setTranslate(weight);
      }
    }
    return {
      swiperPosition,
      swiperDistance,
      swiperRef,
      swiperBool,
      home1,
      home2,
      home3,
      home4,
      activeIndexChange,
      afterInit,
      initSwipe,
      modules: [Pagination, Scrollbar, Virtual],
    };
  },
}
</script>

<style scoped>
.swiper {
  width: 100%;
  height: 100%;
}
:deep(.swiper-pagination){
  display: none;
    margin-right: 50px;
}

</style>
